import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import logo from '../../images/kihi-footer1.png'
import Services from '../../api/Services';



const ClickHandler = () => {
    window.scrollTo(10, 0);
}


const Footer = (props) => {
    const [email, setEmail] = useState('');

    const handleReset = () => {
        setEmail('');
    };
    return (
        <footer className="wpo-site-footer">
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                <div className="logo widget-title">
                                    <img src={logo} alt="blog" />
                                </div>
                                <p>Kihi Enterprises, established in 2020, is a trusted Sole Proprietorship firm engaged as a leading wholesaler of Earth Pit Covers, Earthing Electrodes, Copper Lightning Arresters, Earthing Copper Strips, and a wide range of related products.</p>
                                <div className="social-widget">
                                    {/* <ul>
                                        <li><Link onClick={ClickHandler} to="/"><i className="ti-facebook"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="/"><i className="ti-twitter-alt"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="/"><i className="ti-instagram"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="/"><i className="ti-linkedin"></i></Link></li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>

                        <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Our Products</h3>
                                </div>
                                <ul>
                                    <li><Link onClick={ClickHandler} to="/earthsolutionpage">Earth Solution</Link></li>
                                    <li><Link onClick={ClickHandler} to="/cabletrayspage">Cable Trays</Link></li>
                                    
                                </ul>
                                {/* <ul>
                                    {Services.slice(0, 5).map((service, Sitem) => (
                                        <li key={Sitem}><Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>{service.title}</Link></li>
                                    ))}
                                </ul> */}
                            </div>
                        </div>
                        <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Navigation</h3>
                                </div>
                                <ul>
                                    <li><Link onClick={ClickHandler} to="/">Home</Link></li>
                                    <li><Link onClick={ClickHandler} to="/about">about us</Link></li>
                                    <li><Link onClick={ClickHandler} to="/service-s4">service</Link></li>
                                    {/* <li><Link onClick={ClickHandler} to="/blog">blog</Link></li> */}
                                    <li><Link onClick={ClickHandler} to="/contact">contact us</Link></li>
                                </ul>
                            </div>
                        </div>
                        {/* <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget newsletter-widget">
                                <div className="widget-title">
                                    <h3>Newsletter</h3>
                                </div>
                                <p>Get latest updates and offers</p>
                                <div className="email-from">
                                    <input
                                        className="fild"
                                        type="text"
                                        placeholder="Your email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    <button type="button" onClick={handleReset}>
                                        <i className="ti-arrow-top-right"></i>
                                    </button>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div> 
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-xs-12">
                            <p className="copyright"> Copyright &copy; 2025 <Link onClick={ClickHandler} to="/"></Link>. All
                                Rights Reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;







